import { DashboardEvent } from "../types/DashboardEvent";
import UsbIcon from '@mui/icons-material/Usb';
import UsbOffIcon from '@mui/icons-material/UsbOff';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';

export const iotDeviceEvents: DashboardEvent[ ] = [

    {
        
        displayedText: 'Connected',
        event: 'CONNECTED',
        icon: <UsbIcon sx={{color:'green'}} />
    },

    {
        
        displayedText: 'Disconnected',
        event: 'DISCONNECTED',
        icon: <UsbOffIcon sx={{color:'red'}} />
    },

    {
        
        displayedText: 'Overdue',
        event: 'OVERDUE',
        icon: <PendingActionsIcon sx={{color:'red'}} />
    },

    {
        
        displayedText: 'Missing',
        event: 'MISSING',
        icon: <ContactSupportIcon sx={{color:'red'}} />
    }

];